var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhniconBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61097 10.5599C13.635 14.5828 14.5479 9.92871 17.1101 12.4891C19.5802 14.9585 20.9999 15.4532 17.8703 18.582C17.4783 18.897 14.9876 22.6872 6.23447 13.9365C-2.51974 5.18474 1.26827 2.6915 1.58339 2.2996C4.72057 -0.837787 5.20679 0.590167 7.6769 3.05959C10.2391 5.62103 5.58689 6.53691 9.61097 10.5599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhniconBtn);
export default __webpack_public_path__ + "static/media/phnicon-btn.a3334d73a165c341f8746b0f6e41e8b8.svg";
export { ForwardRef as ReactComponent };